import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'react-native';

import  Theme  from '../theme';

const Heading = ({
  title,
  style,
  headerType = HeadingTypes.HEADING_ONE,
}) => (
    <Text style={[headerType, style]}>{title}</Text>
  );

Heading.propTypes = {
  title: PropTypes.string.isRequired,
  style: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.number,
  ]),
  headerType: PropTypes.object,
};

export const HeadingTypes = {
  HEADING_ONE: {
    fontSize: 18,
    fontFamily: Theme.CustomBold,
  },
  HEADING_TWO: {
    fontSize: 14,
    fontFamily: Theme.CustomBold,
  },
  HEADING_THREE: {
    fontSize: 14,
    fontFamily: Theme.CustomBold,
  },
  HEADING_FOUR: {
    fontSize: 12,
    color: Theme.PRIMARY,
    fontFamily: Theme.CustomBold,
  },
  HEADING_FIVE: {
    fontSize: 13,
    fontFamily: Theme.CustomBold,
  },
  LABEL: {
    fontSize: 11,
    fontFamily: Theme.CustomBold,
  },
};

export default Heading;
